<svelte:options tag="edi-top-referred-students" />

<script lang="ts">
	// Headings prop
	export let headings = []

	export let items = []
</script>

<div class="container">
	<div class="grid-container">
		<div class="heading" id="heading">
			{#each headings as heading}
				<div>{heading}</div>
			{/each}
		</div>

		{#if items.length > 0}
			<div class="data">
				{#each items as data}
					<div>{data?.name}</div>
					<div>
						<a href={data?.link}>{data?.referrals}</a>
					</div>
				{/each}
			</div>
		{:else}
			<div class="default">No Data Available</div>
		{/if}
	</div>
</div>

<style lang="scss">
	.container {
		padding: 10px 10px 10px 10px;
	}

	.heading {
		grid-area: heading;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 1px;
	}

	.heading > div {
		padding-top: 8px;
		padding-bottom: 7px;
	}

	#heading {
		font-weight: bold;
		background: #f5f5f5;
		border-radius: 7px;
	}

	.data {
		grid-area: data;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 1px;
	}

	.data > div {
		padding-top: 5px;
		padding-bottom: 5px;
		border-bottom: 1px solid #f3f3f3;
	}

	.grid-container {
		width: 100%;
		display: grid;
		grid-template-areas:
			'heading'
			'data';
	}

	.grid-container > div {
		background-color: rgba(255, 255, 255, 0.8);
		text-align: center;
		padding: 1px;
		font-family: 'Roboto';
		font-size: 15px;
	}

	a {
		text-decoration: none;
		color: #2757f2;
	}

	a:hover {
		color: #017698;
	}

	.default {
		text-align: center;
		font-family: 'Roboto';
		font-size: 15px;
	}
</style>
